<template>
  <DataTable
    :value="listDataService"
    :lazy="true"
    class="p-datatable-responsive"
    selectionMode="single"
    data-key="id"
    @page="onPage($event)"
    :paginator="pagination"
    :totalRecords="totalRecords"
    :rows="paginationRows"
    :loading="loading"
    :scrollable="(scrollHeight !== '' ? true : false) "
    :scrollHeight="scrollHeight"
    :autoLayout="true"
    filterMatchMode="startsWith"
    :first="firstRecordIndex"
    :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
    :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
    :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column 
      v-for="c in model?.getDisplayFields() || []"
      :key="c.key"
      :field="getField(c)"
      :header="getLabel(c)"
      :ref="getField(c)"
      :filterMatchMode="getFilterMatch(c)"
      :sortable="getSortable(c)"
      :bodyClass="(c.class ? 'txt-' + c.class : '')"
      :bodyStyle="getHeaderStyle(c)"
      :headerStyle="getHeaderStyle(c)"
      :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <!--{{c}}-->
        <img
          v-if="getType(c) == 'Image'"
          :src="getData(c, slotProps.data)"
          style="width: 40px; height: 40px"
        />
        <div
          v-else-if="c.type == 'Text'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'CustomUrl'"
          v-html="callbackCustomUrl(c, slotProps.data)"
          @click="redirectList(slotProps.data, $event)"
          :style="(c.style ? c.style : '')"
        ></div>
        <div
          v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'"
          v-html="getData(c, slotProps.data)"
          :style="(c.style ? c.style : '')"
        ></div>

        <Checkbox
          v-else-if="getType(c) == 'Checkbox'"
          v-model="slotProps.data[slotProps.column.field]"
          :binary="true"
          @change="onInputChange($event, slotProps.data, c)"
        />
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge"  />
            <div v-if="c.custom == 'SelectionText'"  v-html="callbackDataSelect( c ,slotProps.data)"></div>

          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>

      </template>
      <template v-if="c.filter" #filter>
        <InputText
          v-if="c.filter.type == 'input'"
          type="text"
          v-model="filters[$CommonList.getFieldFilter(c)]"
          class="p-column-filter adjust-input"
          :placeholder="getFilterPlaceHolder(c)"
          @keyup="onFilter($event,c.filter.type,c.key)"
        /><!-- :keyup="onFilter(c.filter.type,c.key)"-->
        <!--v-model="filters[getField(c)]"-->
        <Dropdown
          :key="countDropdown"
          v-if="c.filter.type == 'select'"
          v-model="filters[getField(c)]"
          :options="getFilterOptions(c.key)"
          :optionLabel="c.filter.optionLabel"
          :optionValue="c.filter.optionKey"
          :placeholder="getFilterPlaceHolder(c)"
          class="p-column-filter"
          :showClear="true"
          appendTo="body"
          @change="onFilter($event,c.filter.type,c.key)"
          style="width: 100%;"
        >
          <template #option="slotProps">
            <div class="p-clearfix">
              <span
                :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)"
                >{{ slotProps.option[c.filter.optionLabel] }}</span
              >
            </div>
          </template>
        </Dropdown>
        <Calendar 
          v-if="c.filter.type == 'DateRange'"
          :showOnFocus="false" 
          :monthNavigator="true" 
          :yearNavigator="true" 
          yearRange="2020:2300" 
          dateFormat="dd-mm-yy" 
           
          v-model="filters[getField(c)]"
          class="p-column-filter adjust-input"
          :showIcon="true" 
          selectionMode="range"
          appendTo="body"
          :showClear="true"
          :showButtonBar="true"
          @clear-click="onFilter($event,c.filter.type,c.key)"
          @date-select="onFilter($event,c.filter.type,c.key)"
          :manualInput="false"
          style="width: 200px;"
          />
      </template>
    </Column>
    <Column
      v-if="actions"
      headerStyle="width: 10em; text-align: center"
      bodyStyle="width: 10em; text-align: center"
    >
      <template #body="slotProps">
        <span class="p-column-title">Actions</span>
        {{ slotProps.data.color }}
        <Button
          v-for="(a, k) in actions.rows(slotProps.data)"
          :key="k"
          type="button"
          :icon="getIcon(a.icon)"
          :class="getClass(a.name)"
          :disabled="getDisabled(a.disabled)"
          style="margin: 2px"
          v-on:click="actionsClicked(k, a, slotProps)"
        ></Button>
      </template>
      <template #header="slotProps">
        <Button
          v-if="actions.header"
          type="button"
          :icon="getIcon(actions.header.icon)"
          :class="getClass(actions.header.name)"
          v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
export default {
  props: {
    model: Object,
    tableData: Array,
    getFilterOptions: Function,
    actions: Object,
    options: Array,
    whereKeyList: Object,
  },
  data() {
    return {
      //filters: {},
      countDropdown: 0,
      pagination: true, // true cho phép phân trang
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT, // số dòng trên 1 trang
      scrollHeight: '', // chiều cao của trang danh sách
      loading: true,
      rowsPerPageOptions: [10, 20, 50, 100],
      first: 0,
      totalRecords: 120,
      totalRecords2: 12,
      test: null,
      listDataService:null,
      filters: {},
      filtersCustom: [],
      lazyParams: {},
      page_transaction:null,
      firstRecordIndex:0,
    };
  },
  
  async created() {
    // console.log("modelmodelmodelmodelmodelmodelmodelmodelmodel:",this.model)
    // console.log(this.tableData);
    this.test = this.tableData;
    //this.listDataService = await this.dataList();
  },
  mounted () {
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    //  filtersTmp:this.filters
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
        // console.log("this.lazyParamsthis.lazyParams:"+this.page_transaction,this.lazyParams);
         this.firstRecordIndex = this.lazyParams.first;
        // console.log("this.lazyParams:22222222",this.lazyParams);
       /* if (this.lazyParams){
          console.log("this.lazyParams.filters",this.lazyParams.filters);

        }*/
      }
    }
    this.loading = false
    this.countDropdown++;
    this.onLazyEvent();
  },
  methods: {
    select_date(event,col_name) {
      if (this.filters[col_name][0] !== null && this.filters[col_name][1] !== null) {
        this.$emit("filter_date", {
          data: this.filters[col_name],
          col: col_name
        });
      }
    },
    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    cannotEdit(col) {
      if (col.edit && col.edit.edit == false) return true;
      return false;
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.name === "type") style = "width: 5%;";
      else if (col.name === "updated_at") style = "width: 100px;";
      else if (col.name === "active") style = "width: 5%"; 
      return style;
    },
    getData(col, row) {
      var value = '';if (col.type == "Percentage") {
        if (row[col.key] == null) row[col.key] = `0%`;
        value = row[col.key] + "%";
      } else if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if(col.type == "Boolean"){
        if (row[col.key]) {
          value = '<i style="color:#00973E; font-weight: bold;" class="pi pi-check icon-check"></i>';
        } else {
          value = '<i style="color:#E63725; font-weight: bold;" class="pi pi-check icon-times"></i>';
        }
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        value = row[col.key];
      }
      if (col.name === 'growth') {
        value += '%';
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      } 
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      if (col.name === 'growth') {
        filterMatch = 'equals';
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col)}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col)}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams:this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
   async dataList(lazyParams) {
      var offset = lazyParams.first;
      var limit = lazyParams.rows;
      var code = "oyster";
      
      // Get the id from kind_type table where kind_type.code = "oyster"
      var kindTypeQuery = DataServices.getList("kind_type");
      var kindTypeRes = await this.$apollo.mutate({
        mutation: kindTypeQuery,
        variables: {
          where_key: { code: { _eq: code } }
        }
      });
      var kindTypeId = kindTypeRes.data.kind_type[0].id;
      
      var gqLQueryList = DataServices.getList(this.model.tableName);
      var where = {
        deleted: {_eq: false},
        type_id: {_eq: kindTypeId}
      };
      var filters = lazyParams.filters;
      if (filters) {
        for (const [key, value] of Object.entries(filters)) {
          if (value.type_input == 'input') {
            if (!this.$commonFuction.isEmpty(value.value)) {
              if (key == 'email') {
                where['email'] = {_like: "%" + this.$commonFuction.SkipVN(value.value) + "%"};
              } else if (key == 'growth') {
                where[key] = {_eq: parseFloat(value.value)};
              } else {
                where[key] = {_iregex: this.$commonFuction.search(value.value)};
              }
            }
          } else if (value.type_input == 'select') {
            if (key == "active") {
              if (value.value !== undefined && value.value !== null) {
                where['active'] = {_eq: value.value};
              }
            }
          } else if (value.type_input == 'DateRange') {
            if (key == 'rel_date') {
              if (value.value !== undefined && value.value !== null) {
                where['register_members'] = {end_time: {'_gte': value.value.from, '_lte': value.value.to}};
              }
            } else {
              if (value.value !== undefined && value.value !== null) {
                where[key] = {'_gte': value.value.from, '_lte': value.value.to};
              }
            }
          }
        }
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          offset: offset,
          limit: limit,
          orderBy: {created_at: 'desc'}
        }
      });
      var listData = resData.data[this.model.tableName];
    
      var gqLQueryCount = DataServices.countData(this.model.tableName);
      var countRes = await this.$apollo.mutate({
        mutation: gqLQueryCount,
        variables: {
          where_key: where
        }
      });
      var total = countRes.data[this.model.tableName + '_aggregate']['aggregate']['count'];
    
      var dataRes = {
        listData: listData,
        total: total,
      };
      // console.log('dataRes:', dataRes);
      return dataRes;
    },
    
    onLazyEvent() {
      this.lazyParams.filters = this.filtersCustom;
      // console.log('this.lazyParams:', this.lazyParams);
      // console.log('data:', this);
      this.loading = true;
      var that = this;
      this.dataList(this.lazyParams).then(data => {
        //var count = 0;
        if (data.listData.length < 1) {
          that.listDataService = data.listData;
          that.totalRecords = data.total;
          that.loading = false;
        }
        // console.log('listData:', data.listData);
        var stt = this.lazyParams.first;
        for (var i = 0; i < data.listData.length; i++) {
          //album_number ++;
          stt++;
          data.listData[i].stt = stt;
        }
        that.listDataService = data.listData;
        that.totalRecords = data.total;
        that.loading = false;
      });
    },
    redirectList(data, e) {
      let clickedElId = e.target.id
      var path = ``;
      var id = null;
      if (clickedElId === 'list-unit') {
        id = data.id;
        path = `/admin/list-unit`;
        this.$router.push({path: path, query: {compay_id: id}})
      } else if (clickedElId === 'list-type') {
        id = data.id;
        path = `/admin/list-type`;
        this.$router.push({path: path, query: {company_id: id}})
      }
    },
    callbackCustomUrl(c,data){
      var text = ''
      switch(c.key) {
        case 'units':
            // text = '<a class="txt-link text-active" id="list-unit" :data-id="'+data.id+'">'+data.units+'</a>';
          break;
        case 'type':
            // text = '<a class="txt-link text-active" id="list-type" :data-id="'+data.id+'">'+data.type+'</a>';
            text = data.type;
          break;
        default:
          break;
      }
      // this.date_now
      return text;
    },
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'status':
          if(data.status == 'actived'){
            text += `<span style="color:#A1000F;"><i class="pi pi-check" style="font-size: 20px;font-weight: 900;"></i></span>`; 
          }
          break;
        case 'active':
          // console.log("data.active hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",data.active);
          if(data.active === true){
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-check" style="color: #00973D;"/></div>';
          }else{
            text += '<div style="text-align: center;"><i class="fa fa-solid fa-times" style="color: #E95D57;"/></div>';
          }
          break;

        case 'deleted':
          if (data.deleted === true){
            text += `<span style="color:red;"><i class="pi pi-check" style="font-size: 20px;font-weight: 900;"></i></span>`; 
          }
          break;
        default:
      }
      return text;
    },


    onPage(event) {
      // console.log("eventeventeventevent",event);
      this.lazyParams = event;
      this.onLazyEvent();
    },
    async onFilter(event, type_input, key) {
      // Ensure the filter only accepts numeric values for the 'growth' field and allows decimal numbers
      if (key === 'growth' && isNaN(event.target.value.replace('.', ''))) {
      this.filters[key] = '';
      return;
      }
      //this.loading = true;
      this.tableData = this.test;
      // console.log('this.test',this.test);
      // console.log('this.test',this.tableData);
      // console.log('tableData',this.whereKeyList);
      // console.log('filters:',this.filters);
      
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);

      this.lazyParams.first = 0;
      this.onLazyEvent()
      /*setTimeout(() => {
        this.customers = this.datasource.slice(event.first, event.first + event.rows);
        this.loading = false;
      }, 500);*/
    },
  }
};
</script>
<style lang="scss">
.p-paginator-bottom{padding: 0 !important;}
.adjust-input{width: 100% !important;}
</style>